import { z } from "zod/v4";
import { announcementSchema, type CreateAnnouncementPayload } from "../schemas/announcement";
import { fetchApi, fetchVoid } from "./internal";

export const announcements = {
	list: (clubId: string) => fetchApi(`/clubs/${clubId}/announcements`, z.array(announcementSchema)),
	create: (clubId: string, payload: CreateAnnouncementPayload) =>
		fetchApi(`/clubs/${clubId}/announcements`, announcementSchema, {
			method: "POST",
			body: JSON.stringify(payload),
		}),
	delete: (clubId: string, announcementId: string) =>
		fetchVoid(`/clubs/${clubId}/announcements/${announcementId}`, {
			method: "DELETE",
		}),
};
